import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { GomusCommonModule } from '@gomus/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { GomusHttpInterceptor } from './shared/components/http/http.interceptor';
import { BarcoderService } from './shared/services/barcoder.service';
import { ConfigResolver } from './shared/services/config-resolver.service';
import { ConfigService } from './shared/services/config.service';
import { RollbarErrorHandler, rollbarFactory, RollbarService } from './shared/services/error-handler.service';
import { OrderService } from './shared/services/order.service';
import { commonModuleOptions } from './common-options';
import { LanguageRouteService } from './shared/services/language-route.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CommonModule,
    GomusCommonModule.forRoot(commonModuleOptions()),
    AppRoutingModule,
    HttpClientModule,
    NoopAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => new TranslateHttpLoader(http, './assets/i18n/', '.json'),
        deps: [HttpClient]
      }
    }),
  ],
  providers: [
    { provide: ErrorHandler, useClass: RollbarErrorHandler },
    { provide: RollbarService, useFactory: rollbarFactory },
    ConfigResolver,
    ConfigService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GomusHttpInterceptor,
      multi: true,
    },
    OrderService,
    BarcoderService,
    LanguageRouteService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {}
}
